// Admin token gate. Stored in sessionStorage (not localStorage) so it's
// scoped to the current browser tab and auto-cleared on tab close —
// shrinks the XSS attack window vs. long-lived localStorage tokens.
const KEY = "pshl_admin_token";
const store = typeof window !== "undefined" ? window.sessionStorage : null;

export const setAdminToken = (token) => {
  if (!store) return;
  if (token) store.setItem(KEY, token);
  else store.removeItem(KEY);
};
export const getAdminToken = () => (store ? store.getItem(KEY) || "" : "");
export const clearAdminToken = () => { if (store) store.removeItem(KEY); };
export const adminHeaders = () => {
  const t = getAdminToken();
  return t ? { "X-Admin-Token": t } : {};
};
